<div class="bienvenidof">
    <h3>Bienvenid@</h3>
    <p>al dasboard gestión integral de afiliados</p>
    <ul>
        <li>+ Funcionalidades</li>
        <li>+ Rendimiento</li>
        <li>+ Información oportuna</li>
    </ul>
</div>